// extracted by mini-css-extract-plugin
module.exports = {"halfsy":"halfsy_halfsy__1uPX_","feature":"halfsy_feature__3Q1G4","left":"halfsy_left__2iTmN","right":"halfsy_right__3p24l","btn":"halfsy_btn__3X5cA"};